module.exports = __webpack_public_path__ + "img/1383143636.6ca432dc.jpg";